export default {
  fetchProjectListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/project")
        .then((response) => {
          commit('SET_PROJECTS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
